import { ChangeDetectionStrategy, Component, input, OnInit, output, TemplateRef, ViewChild } from '@angular/core';
import { MeasurementUnit, RoomListItem } from '../../models';
import { defaultRoomListColumns, dropDownMenuPosition } from '../../consts';
import { Column } from '@nx-customer-apps/shared/interfaces';
import { MatIconButton } from '@angular/material/button';
import { CdkMenuTrigger, CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { RoomListComponent } from '../room-list/room-list.component';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { ValueWithUnitPipe } from '../../pipes/value-with-unit.pipe';
import { RoomTypePipe } from '../../pipes/room-type.pipe';
import { SectionComponent } from '../../shared';
import { ComponentsModule } from '@nx-customer-apps/components';
import { RoomEditorComponent } from '../room-editor/room-editor.component';
import { AddRoomsComponent } from '../add-rooms/add-rooms.component';
import { AddRoomsEvent, Level } from '../../models';
import { LevelNamePipe } from '../../pipes/level-name.pipe';

@Component({
    selector: 'rbr-level-rooms-panel',
    templateUrl: './level-rooms-panel.component.html',
    styleUrl: './level-rooms-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        SectionComponent,
        ComponentsModule,
        MatIconButton,
        CdkMenuTrigger,
        RoomListComponent,
        RoomEditorComponent,
        CdkMenu,
        CdkMenuItem,
        MatTooltip,
        TranslatePipe,
        ValueWithUnitPipe,
        RoomTypePipe,
        LevelNamePipe,
        AddRoomsComponent
    ]
})
export class LevelRoomsPanelComponent implements OnInit {
    levels = input<Level[]>([]);
    level = input<Level | null>(null);
    addRooms = output<AddRoomsEvent>();
    deleteLevel = output<void>();
    toggleCooling = output<{ roomId: number; cooling: boolean }>();
    toggleHeating = output<{ roomId: number; heating: boolean }>();
    deleteRoom = output<number>();
    editRoom = output<number>();
    columns: Column[] = [];
    measurementUnit = MeasurementUnit;
    dropDownMenuPosition = dropDownMenuPosition;

    @ViewChild('roomNameCellEl', { static: true, read: TemplateRef }) public roomNameCellEl!: TemplateRef<any>;
    @ViewChild('roomAreaCellEl', { static: true, read: TemplateRef }) public roomAreaCellEl!: TemplateRef<any>;
    @ViewChild('roomHeightCellEl', { static: true, read: TemplateRef }) public roomHeightCellEl!: TemplateRef<any>;
    @ViewChild('roomTypeCellEl', { static: true, read: TemplateRef }) public roomTypeCellEl!: TemplateRef<any>;
    @ViewChild('roomIsCooledCellEl', { static: true, read: TemplateRef }) public roomIsCooledCellEl!: TemplateRef<any>;
    @ViewChild('roomCoolingLoadCellEl', { static: true, read: TemplateRef }) public roomCoolingLoadCellEl!: TemplateRef<any>;
    @ViewChild('roomIsHeatedCellEl', { static: true, read: TemplateRef }) public roomIsHeatedCellEl!: TemplateRef<any>;
    @ViewChild('roomHeatingLoadCellEl', { static: true, read: TemplateRef }) public roomHeatingLoadCellEl!: TemplateRef<any>;
    @ViewChild('roomActionsCellEl', { static: true, read: TemplateRef }) public roomActionsCellEl!: TemplateRef<any>;

    async ngOnInit() {
        this.initColumns();
    }

    private initColumns(): void {
        this.columns = defaultRoomListColumns.map(column => {
            switch (column.name) {
                case 'name':
                    return { ...column, templateRef: this.roomNameCellEl };
                case 'area':
                    return { ...column, templateRef: this.roomAreaCellEl };
                case 'height':
                    return { ...column, templateRef: this.roomHeightCellEl };
                case 'type':
                    return { ...column, templateRef: this.roomTypeCellEl };
                case 'isCooled':
                    return { ...column, templateRef: this.roomIsCooledCellEl };
                case 'coolingLoad':
                    return { ...column, templateRef: this.roomCoolingLoadCellEl };
                case 'isHeated':
                    return { ...column, templateRef: this.roomIsHeatedCellEl };
                case 'heatingLoad':
                    return { ...column, templateRef: this.roomHeatingLoadCellEl };
                case 'actions':
                    return { ...column, templateRef: this.roomActionsCellEl };
                default:
                    break;
            }
            return column;
        });
    }
}
